export default "__VITE_ASSET__B5f891tD__"